MW.elements.$main = $('div[role=main]');
MW.elements.$trackingData = $('.tracking-data');
MW.elements.$tracking = $('.tracking');
MW.elements.$modal = $('#modal');